const action = name => `ADV.FINANCIAL_PLAN_GOAL_DROPDOWN.${name}`;

export const SET_GOAL_ID = action('SET_GOAL_ID');
export const SET_SUB_GOAL_TYPE = action('SET_SUB_GOAL_TYPE');

export const setGoalId = (goalId, clientId) => ({
  type: SET_GOAL_ID,
  clientId,
  goalId,
});

export const setSubGoalType = (subGoalTypeId, clientId) => ({
  type: SET_SUB_GOAL_TYPE,
  clientId,
  subGoalTypeId,
});
